(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    
  // Esegui dopo che Shopify ha caricato la sezione
  if (typeof window.faqInitialized === 'undefined') {
    window.faqInitialized = true;

    function initFAQ() {
      // Tab switching
      const tabItems = document.querySelectorAll('.faq-tab-item');
      const tabContents = document.querySelectorAll('.faq-tab-content');

      tabItems.forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.preventDefault();
          const targetTab = this.getAttribute('data-tab');

          // Remove active class from all tabs
          tabItems.forEach(function (tab) {
            tab.classList.remove('active');
          });
          tabContents.forEach(function (content) {
            content.classList.remove('active');
          });

          // Add active class to clicked tab
          this.classList.add('active');
          const targetContent = document.getElementById(targetTab);
          if (targetContent) {
            targetContent.classList.add('active');
          }
        });
      });

      // Accordion functionality
      const questions = document.querySelectorAll('.faq-question');

      questions.forEach(function (question) {
        question.addEventListener('click', function (e) {
          e.preventDefault();
          const answer = this.nextElementSibling;
          const isOpen = answer.classList.contains('open');

          // Close all answers in the same card container
          const parentContent = this.closest('.faq-tab-content');
          if (parentContent) {
            parentContent.querySelectorAll('.faq-answer').forEach(function (ans) {
              ans.classList.remove('open');
            });
            parentContent.querySelectorAll('.faq-question').forEach(function (q) {
              q.classList.remove('active');
            });
          }

          // Toggle current answer
          if (!isOpen) {
            answer.classList.add('open');
            this.classList.add('active');
          }
        });
      });
    }

    // Inizializza quando il DOM è pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFAQ);
    } else {
      initFAQ();
    }

    // Re-inizializza dopo che Shopify carica la sezione nell'editor
    document.addEventListener('shopify:section:load', initFAQ);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
